import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=a36a6f44&scoped=true&"
import script from "./Attachments.vue?vue&type=script&lang=js&"
export * from "./Attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a6f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36a6f44')) {
      api.createRecord('a36a6f44', component.options)
    } else {
      api.reload('a36a6f44', component.options)
    }
    module.hot.accept("./Attachments.vue?vue&type=template&id=a36a6f44&scoped=true&", function () {
      api.rerender('a36a6f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/components/products/preview/Attachments.vue"
export default component.exports